import {useQueryParam} from 'use-query-params';
import {type QueryParamConfig} from 'serialize-query-params';
import isEqual from 'lodash/isEqual';

export const useTypedQueryParam = <T>(name: string, paramConfig: QueryParamConfig<T, any>) => {

    const [value, setValue] = useQueryParam<T>(name, {
        ...paramConfig,
        equals: isEqual,
    }, {
        skipUpdateWhenNoChange: true,
        removeDefaultsFromUrl: true,
    });

    return [value, setValue] as const;
};
